import React from 'react';

const Table = ({ 
  columns, 
  data, 
  loading = false, 
  error = null,
  emptyMessage = "Нет данных",
  className = ""
}) => {
  if (loading) {
    return (
      <div className="text-center py-4 text-gray-600 dark:text-gray-300">
        Загрузка...
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-4 text-red-600 dark:text-red-400">
        Ошибка: {error}
      </div>
    );
  }

  return (
    <div className={`overflow-x-auto rounded-xl border border-gray-200 dark:border-gray-700 mb-2 ${className}`}>
      <table className="min-w-full bg-white dark:bg-gray-800 rounded-xl text-xs sm:text-sm transition-colors">
        <thead>
          <tr className="bg-blue-50 dark:bg-gray-700 text-blue-800 dark:text-blue-200 text-left">
            {columns.map((column, index) => (
              <th 
                key={index}
                className={`px-3 py-3 text-left font-semibold text-gray-700 dark:text-gray-300 bg-gray-50 dark:bg-gray-700/50 ${column.className || ''}`}
              >
                {column.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="px-3 py-3 text-center text-gray-600 dark:text-gray-400">
                {emptyMessage}
              </td>
            </tr>
          ) : (
            data.map((row, rowIndex) => (
              <tr 
                key={rowIndex}
                className={`border-t border-gray-200 dark:border-gray-700 transition ${
                  rowIndex % 2 === 0 
                    ? 'bg-blue-50 dark:bg-gray-900/40' 
                    : 'bg-white dark:bg-gray-800/80'
                } hover:bg-blue-50 dark:hover:bg-gray-700`}
              >
                {columns.map((column, colIndex) => (
                  <td 
                    key={colIndex}
                    className={`px-3 py-3 border-t border-gray-200 dark:border-gray-700 ${column.cellClassName || ''}`}
                  >
                    {column.render ? column.render(row, rowIndex) : row[column.key]}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
